import { useTranslation } from '../hooks/useTranslation';

export const useTranslatedServices = () => {
  const { t } = useTranslation();

  return [
    {
      title: t('services.session_1'),
      price: t('services.session_1_price'),
      desc: t('services.session_1_desc'),
      bullets: [
        t('services.features.consultation'),
        t('services.features.diagnosis'),
        t('services.features.session'),
        t('services.features.recommendations'),
      ],
      popular: false
    },
    {
      title: t('services.package_deep'),
      price: t('services.package_deep_price'),
      desc: t('services.package_deep_desc'),
      bullets: [
        t('services.features_package.consultation'),
        t('services.features_package.diagnosis'),
        t('services.features_package.session'),
        t('services.features_package.recommendations'),
        t('services.features_package.support'),
        t('services.features_package.bonus'),
      ],
      popular: false,
    },
    {
      title: t('services.students'),
      price: t('services.students_price'),
      desc: t('services.students_desc'),
      bullets: [
        t('services.features.consultation'),
        t('services.features.diagnosis'),
        t('services.features.session'),
        t('services.features.recommendations')
      ],
      popular: false
    }
  ];
};
